$(document).ready(function () {
  if (!$("header .header-container").hasClass("type9")) {
    const nav = document.querySelector(".main-navigation");
    const dropMenu = document.querySelectorAll(".groups > .menu-wrapper");
    const triggers = document.querySelectorAll(".groups > a");
    //console.log(triggers);

    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener("click", function (e) {
        e.preventDefault();
        let dropdown = this.nextElementSibling;
        if (dropdown.classList.contains("active")) {
          dropdown.classList.remove("active");
          dropdown.style.maxHeight = null;
        } else {
          for (const trigger of triggers) {
            if (trigger.nextElementSibling.classList.contains("active")) {
              trigger.nextElementSibling.classList.remove("active");
              trigger.nextElementSibling.style.maxHeight = null;
            }
          }

          if (dropdown.style.maxHeight) {
            dropdown.style.maxHeight = null;
          } else {
            dropdown.style.maxHeight = dropdown.scrollHeight + "px";
          }
          dropdown.classList.add("active");
        }
      });
    }
  }

  // Sticky Header
  var scrolled = false;
  $(window).scroll(function () {
    if (150 < $(window).scrollTop() && !scrolled) {
      var $headerContainer = $(".header-container");
      if ($(".main-section-header").height() != 0) {
        $(".main-section-header").height($headerContainer.height());
      }
      $headerContainer.addClass("sticky-header");
      $(".header-container .main-nav").addClass("container");
      scrolled = true;
    }
    if (150 > $(window).scrollTop() && scrolled) {
      $(".main-section-header").height("auto");
      $(".header-container").removeClass("sticky-header");
      $(".header-container .main-nav").removeClass("container");
      scrolled = false;
    }
  });

  // new megamenu start //
  $(".rt-desktop-menu .top-navigation .level0.level-top").each(function () {
    let urlL1 = $(this).find("> a.level-top").attr("href");
    let urlKey = urlL1.substring(urlL1.lastIndexOf("/"));
    let currentUrl = $(location).attr("href");
    let currentUrlKey = currentUrl.substring(currentUrl.lastIndexOf("/"));
    if (urlKey == currentUrlKey) $(this).addClass("active");
  });
  $("#mobile-menu li.level0.level-top").each(function () {
    let self = $(this);
    self.find("span.collapse.level0").click(function () {
      if (self.hasClass("open-slide")) {
        self.removeClass("open-slide");
        self.find(".level0-wrapper").removeClass("open-slide-child");
      } else {
        $("#mobile-menu li.level0.level-top").removeClass("open-slide");
        self.addClass("open-slide");
        $("#mobile-menu li.level0.level-top .level0-wrapper").removeClass(
          "open-slide-child"
        );
        self.find(".level0-wrapper").addClass("open-slide-child");
      }

      self.find("li.level1").each(function () {
        let selfL1 = $(this);
        selfL1.find("span.collapse.level1").click(function () {
          if (selfL1.hasClass("level1-opened")) {
            selfL1.removeClass("level1-opened");
            selfL1.find("ul.level1").stop().slideUp();
          } else {
            self.find("li.level1").removeClass("level1-opened");
            selfL1.addClass("level1-opened");
            self.find("li.level1 ul.level1").stop().slideUp();
            selfL1.find("ul.level1").stop().slideDown();
          }
        });
      });

      if (self.find("ul.level0").hasClass("static")) {
        self.find("li.level2").each(function () {
          let selfL2 = $(this);
          selfL2.find("span.collapse.level2").click(function () {
            if (selfL2.hasClass("level2-opened")) {
              selfL2.removeClass("level2-opened");
              selfL2.find("ul.level2").stop().slideUp();
            } else {
              self.find("li.level2").removeClass("level2-opened");
              self.find("li.level2 ul.level2").stop().slideUp();
              selfL2.addClass("level2-opened");
              selfL2.find("ul.level2").stop().slideDown();
            }
          });
        });
      }
    });
  });
});
// new megamenu end //

function sliderBidvino(mainClass, ms_slide, d_slide, t_slide, m_slide) {
  $(mainClass).slick({
    infinite: true,
    arrow: false,
    speed: 300,
    slidesToShow: ms_slide,
    slidesToScroll: ms_slide,
    // variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: d_slide,
          slidesToScroll: d_slide,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: t_slide,
          slidesToScroll: t_slide,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: m_slide,
          slidesToScroll: m_slide,
        },
      },
    ],
  });
}

sliderBidvino(".wineries-by-region-main .row", 3, 3, 2, 2);
sliderBidvino(".bundle-products-grid.row", 3, 3, 2, 2);
sliderBidvino(".rt-product-collection-grid-main .products-grid", 4, 3, 2, 1);

$(document).ready(function () {
  // homepage blog
  $(".rt-blogs-section .post-carousel").slick({
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Homepage accesories grid

  $(".products-related .products-grid").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrow: false,
          infinite: false,
          slidesToShow: 1.5,
          slidesToScroll: 1.5,
        },
      },
    ],
  });
  if ($(window).width() < 992) {
    $(
      ".footer-middle .info-footer .widget-wrapper .custom-footer-content, .footer-middle .info-footer .rt-contact-us-details"
    ).hide();
    $(".footer-middle .info-footer").each(function () {
      let self = $(this);
      self.find(".widget-wrapper .footer-block-title").click(function () {
        self
          .find(
            ".widget-wrapper .custom-footer-content, .rt-contact-us-details"
          )
          .slideToggle();
        self.toggleClass("active");
      });
    });

    $(document).click(function () {
      $(".header-right .search-extended").hide();
    });
  }
});

var BV = BV || {};

(function ($) {
  BV.page = {
    headerInit: function () {
      $(".search-area a.search-icon").click(function (e) {
        $(".top-links-icon")
          .parent()
          .children()
          .children("ul.links")
          .removeClass("d-block");
        if ($(".search-extended").is(".show")) {
          $(".search-extended").removeClass("d-block");
        } else {
          $(".search-extended").addClass("d-block");
        }

        e.stopPropagation();
      });

      $(".top-links-icon").click(function (e) {
        $(".search-area a.search-icon")
          .parent()
          .children(".search-extended")
          .removeClass("d-block");
        if (
          $(this).parent().children().children("ul.links").hasClass("d-block")
        ) {
          $(this)
            .parent()
            .children()
            .children("ul.links")
            .removeClass("d-block");
        } else {
          $(this).parent().children().children("ul.links").addClass("d-block");
        }

        e.stopPropagation();
      });

      $(".search-area a.search-icon")
        .parent()
        .click(function (e) {
          e.stopPropagation();
        });

      $(".mini-cart").hover(
        function () {
          $(this).children().children(".cart-wrapper").fadeIn(200);
        },
        function () {
          $(this).children().children(".cart-wrapper").fadeOut(200);
        }
      );

      $("html,body").click(function () {
        $(".top-links-icon")
          .parent()
          .children()
          .children("ul.links")
          .removeClass("d-block");
        $(".search-area a.search-icon")
          .parent()
          .children(".search-extended")
          .removeClass("d-block");
      });

      $(".menu-icon, .mobile-nav-overlay, .close-sidebar-menu").click(function (
        event
      ) {
        if (
          !$("body").hasClass("md-mobile-menu") &&
          ($(".header-container").hasClass("type11") ||
            $(".header-container").hasClass("type13") ||
            $(".header-container").hasClass("type7"))
        ) {
          $("body").addClass("md-mobile-menu");
        }

        if (!$("body").hasClass("mobile-nav-shown")) {
          $("body").addClass("mobile-nav-shown", function () {
            setTimeout(function () {
              $(document).one("click", function (e) {
                var target = e.target;
                if (
                  !$(target).is(".mobile-nav") &&
                  !$(target).parents().is(".mobile-nav")
                ) {
                  $("body").removeClass("mobile-nav-shown");
                  $(".open-slide-child .collapse.level0").trigger('click');
                }
              });
            }, 111);
          });
        } else {
          $("body").removeClass("mobile-nav-shown");
          $(".mobile-nav").removeClass("d-block");
          $(".open-slide-child .collapse.level0").trigger('click');
        }
      });
      $(".header-container .toggle-menu .menu-container>a").click(function () {
        if ($(this).next().find(".main-navigation").hasClass("show")) {
          $(this).next().find(".main-navigation").removeClass("show");
          $(this).parents(".toggle-menu").removeClass("open");
        } else {
          $(this).next().find(".main-navigation").addClass("show");
          $(this).parents(".toggle-menu").addClass("open");
        }

        if ($(window).width() <= 991) {
          if ($(".mobile-nav").hasClass("d-block")) {
            $(".mobile-nav").removeClass("d-block");
            $(".mobile-nav").slideUp();
            $("body").removeClass("mobile-nav-shown");
          } else {
            $(".mobile-nav").addClass("d-block");
            $(".mobile-nav").slideDown();
            $("body").addClass("mobile-nav-shown", function () {
              setTimeout(function () {
                $(document).one("click", function (e) {
                  var target = e.target;
                  if (
                    !$(target).is(".mobile-nav") &&
                    !$(target).parents().is(".mobile-nav")
                  ) {
                    $("body").removeClass("mobile-nav-shown");
                    $(".open-slide-child .collapse.level0").trigger('click');
                  }
                });
                
              }, 111);
            });
          }
        }
      });
    },
    simpleDropdown: function () {
      $(".input-dropdown-inner").each(function () {
        var dd = $(this);
        var btn = dd.find("> a");
        var input = dd.find("> input");
        var list = dd.find("> .list-wrapper");
        inputPadding();

        $(document).click(function (e) {
          var target = e.target;
          if (
            dd.hasClass("dd-shown") &&
            !$(target).is(".input-dropdown-inner") &&
            !$(target).parents().is(".input-dropdown-inner")
          ) {
            hideList();
            return false;
          }
        });

        btn.on("click", function (e) {
          e.preventDefault();
          if (dd.hasClass("dd-shown")) {
            hideList();
          } else {
            showList();
          }
          return false;
        });

        list.on("click", "a", function (e) {
          e.preventDefault();
          var value = $(this).data("val");
          var label = $(this).html();
          list.find(".current-item").removeClass("current-item");
          $(this).parent().addClass("current-item");

          if (value != 0) {
            list.find("ul:not(.children) > li:first-child").show();
          } else if (value == 0) {
            list.find("ul:not(.children) > li:first-child").hide();
          }

          btn.html(label);
          input.val(value);
          $(this)
            .closest("form.has-categories-dropdown")
            .attr("action", "/search/collections/" + value);
          hideList();
          inputPadding();
        });

        function showList() {
          dd.addClass("dd-shown");
          list.slideDown(100);
        }

        function hideList() {
          dd.removeClass("dd-shown");
          list.slideUp(100);
        }

        function inputPadding() {
          var paddingValue =
              dd.innerWidth() +
              dd.parent().siblings(".searchsubmit").innerWidth() +
              17,
            padding = "padding-right";
          if ($("body").hasClass("rtl")) {
            padding = "padding-left";
          }
          dd.parent().parent().find(".s").css(padding, paddingValue);
        }
      });
    },
  };

  BV.page.headerInit();
  BV.page.simpleDropdown();
})(jQuery);

// Custom form
"undefined" == typeof Shopify && (Shopify = {}),
  (window.form = window.form || {}),
  (form.cacheSelectors = function () {
    form.cache = {
      $html: $("html"),
      $body: $("body"),
      $recoverPasswordLink: $("#RecoverPassword"),
      $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
      $recoverPasswordForm: $("#RecoverPasswordForm"),
      $customerLoginForm: $("#CustomerLoginForm"),
      $passwordResetSuccess: $("#ResetSuccess"),
    };
  }),
  (form.init = function () {
    form.cacheSelectors(), form.loginForms();
  }),
  (form.getHash = function () {
    return window.location.hash;
  }),
  (form.updateHash = function (a) {
    (window.location.hash = "#" + a),
      $("#" + a)
        .attr("tabindex", -1)
        .focus();
  }),
  (form.loginForms = function () {
    function a() {
      form.cache.$recoverPasswordForm.show(),
        form.cache.$customerLoginForm.hide();
    }
    function b() {
      form.cache.$recoverPasswordForm.hide(),
        form.cache.$customerLoginForm.show();
    }
    form.cache.$recoverPasswordLink.on("click", function (b) {
      b.preventDefault(), a();
    }),
      form.cache.$hideRecoverPasswordLink.on("click", function (a) {
        a.preventDefault(), b();
      }),
      "#recover" == form.getHash() && a();
  }),
  (form.resetPasswordSuccess = function () {
    form.cache.$passwordResetSuccess.show();
  }),
  $(form.init);

const addToCart = () => {
  $(".ajax_add_to_cart").each(function () {
    const atc = $(this);
    const form = atc.closest("form");
    atc.click(async function (e) {
      e.preventDefault();
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        data: form.serialize(),
        dataType: "json",
        beforeSend: function () {
          $("#resultLoading").show();
        },
        success: function () {
          setTimeout(async function () {
            let cartRes = await fetch(window.location.href);
            cartRes = await cartRes.text();
            let parser = new DOMParser();
            let doc = parser.parseFromString(cartRes, "text/html");
            let minicartUpdate = doc.querySelector(".mini-cart").innerHTML;
            document.querySelector(".mini-cart").innerHTML = minicartUpdate;
            $("#resultLoading").hide();
            $(".mini-cart").trigger('mouseenter');
            setTimeout(function () { $(".mini-cart").trigger('mouseleave'); },2000);
          }, 500);
         
        },
        error: function () {
          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: form.serialize(),
            dataType: "json",
            beforeSend: function () {
              $("#resultLoading").show();
            },
            success: function () {
              setTimeout(async function () {
                let cartRes = await fetch(window.location.href);
                cartRes = await cartRes.text();
                let parser = new DOMParser();
                let doc = parser.parseFromString(cartRes, "text/html");
                let minicartUpdate = doc.querySelector(".mini-cart").innerHTML;
                document.querySelector(".mini-cart").innerHTML = minicartUpdate;
                $("#resultLoading").hide();
                $(".mini-cart").trigger('mouseenter');
                setTimeout(function () { $(".mini-cart").trigger('mouseleave'); },2000);
              }, 500);
            },
            error: function () {
              $("#resultLoading").hide();
            },
          });
        },
      });
    });
  });
}
addToCart();

// Search by only product title
let initV = $(".searchform input.s").val();
$(".searchform input.s").val(initV.replace("title:", ""));
$(".searchform button.searchsubmit").click(function () {
  var oldV = $(".searchform input.s").val();
  if (oldV) {
    $(".searchform input.s").val("title:" + oldV);
  }
});

// Back top scroll
jQuery("#back-top a").click(function () {
  return jQuery("body,html").animate({ scrollTop: 0 }, 800), !1;
});

$(document).ready(function() {
    $('.js-qty__adjust').on('click', function(e) {
        e.preventDefault();
        var $input = $(this).siblings('.js-qty__num');
        var currentVal = parseInt($input.val(), 10);
        var min = parseInt($input.attr('min'), 10);
        var max = parseInt($input.attr('max'), 10);
        var step = parseInt($input.attr('step'), 10);   
        if ($(this).hasClass('js-qty__adjust--plus')) {
            if (max && currentVal + step > max) {
                $input.val(max);
            } else {
                $input.val(currentVal + step);
            }
        } else if ($(this).hasClass('js-qty__adjust--minus')) {
            if (min && currentVal - step < min) {
                $input.val(min);
            } else {
                $input.val(currentVal - step);
            }
        }
        $input.trigger('change');
    });
});
